import { useNotifyChange, useOnChange } from 'hooks/useChangeSignal';

// A task changed in its panel or its form: the lists that show it reload
// (the home page, the tasks page, the count of the sidebar).
export const TASKS_CHANGED = 'tasks_changed';

export const useNotifyTasksChanged = () => useNotifyChange(TASKS_CHANGED);

const useTasksChanged = (onChanged) => useOnChange(TASKS_CHANGED, onChanged);

export default useTasksChanged;
